// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-container {
  display: inline-block;
  position: relative;
}

.wallet-address {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.3s, box-shadow 0.3s;
  border: 1px solid transparent;
}

.wallet-address:hover {
  background-color: #0056b3;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-color: #003d7a;
}

.wallet-address:focus {
  outline: none;
}

.copy-message {
  position: absolute;
  top: 40px;
  left: 100px;
  transform: translateX(-50%);
  margin-top: 8px;
  background-color: #19c742;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/User-panel/UserLayout/navbar.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kDAAkD;EAClD,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".wallet-container {\n  display: inline-block;\n  position: relative;\n}\n\n.wallet-address {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: #fff;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background-color 0.3s, box-shadow 0.3s;\n  border: 1px solid transparent;\n}\n\n.wallet-address:hover {\n  background-color: #0056b3;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border-color: #003d7a;\n}\n\n.wallet-address:focus {\n  outline: none;\n}\n\n.copy-message {\n  position: absolute;\n  top: 40px;\n  left: 100px;\n  transform: translateX(-50%);\n  margin-top: 8px;\n  background-color: #19c742;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
